var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1800_586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7915 5.1665V7.9165H8.37484V18.9165H11.1248V7.9165H15.7082V5.1665H3.7915ZM21.2082 9.74984H12.9582V12.4998H15.7082V18.9165H18.4582V12.4998H21.2082V9.74984Z",
    fill: "#28519E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1800_586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1.5 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicon);
export default __webpack_public_path__ + "static/media/T icon.38bab14bcc53834e0a05629a9a8ffdf2.svg";
export { ForwardRef as ReactComponent };